import { useMutation } from "@tanstack/react-query";
import { Favorites } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
const putFavoriteItem = async (grn) => Favorites.addItemToFavorites(grn);
const deleteFavoriteItem = (grn) => Favorites.removeItemFromFavorites(grn);
const useFavoriteItemMutation = () => {
  const putMutation = useMutation({
    mutationFn: putFavoriteItem,
    onError: (errorThrown) => {
      UserNotification.error(
        `Adding item to favorites failed with status: ${errorThrown}`,
        "Could not add item to favorites"
      );
    }
  });
  const deleteMutation = useMutation({
    mutationFn: deleteFavoriteItem,
    onError: (errorThrown) => {
      UserNotification.error(
        `Deleting item from favorites failed with status: ${errorThrown}`,
        "Could not delete item from favorites"
      );
    }
  });
  return { putItem: putMutation.mutateAsync, deleteItem: deleteMutation.mutateAsync };
};
export default useFavoriteItemMutation;
